import type { RemovableRef } from "@vueuse/core"
import { ModelLogLevel } from "@/utils/useEngineModel"
import { useLocalStorage } from "@vueuse/core"
import { defineStore } from "pinia"

interface State {
  logLevel: RemovableRef<ModelLogLevel>
  showSelectMessage: RemovableRef<boolean>
  autoImportDefaultModel: RemovableRef<boolean> // latch to avoid a reload loop
  navOpened: RemovableRef<boolean>
  myoLayoutOpened: RemovableRef<boolean> // For `Make your own` view
  showIdentifiers: RemovableRef<boolean> // Show UUIds for dashboard items
  closedBanners: RemovableRef<string[]> // List of closed banners
}

export const useSettingsStore = defineStore("settings", {
  state: (): State => ({
    logLevel: useLocalStorage<ModelLogLevel>("log_level", ModelLogLevel.Info),
    showSelectMessage: useLocalStorage<boolean>("locate_message", true),
    autoImportDefaultModel: useLocalStorage<boolean>(
      "auto_import_default",
      true
    ),
    navOpened: useLocalStorage<boolean>("nav_opened", true),
    myoLayoutOpened: useLocalStorage<boolean>("myo_layout_opened", true),
    closedBanners: useLocalStorage<string[]>("closedBanners", []),
    showIdentifiers: useLocalStorage<boolean>("show_identifiers", false),
  }),
  getters: {
    defaultModel(): string {
      const defaultModel = import.meta.env.VITE_DEFAULT_MODEL
      if (defaultModel && defaultModel.length > 0) {
        return defaultModel
      }

      return ""
    },
    shouldImportDefaultModel(): boolean {
      return this.autoImportDefaultModel && this.defaultModel.length > 0
    },
  },
  actions: {
    resetSettings() {
      this.showSelectMessage = true
      this.autoImportDefaultModel = true
      this.navOpened = true
      this.myoLayoutOpened = true
      this.closedBanners = []
    },
    toggleNavOpened() {
      this.navOpened = !this.navOpened
    },
    resetBannerList() {
      this.closedBanners = []
    },
    addClosedBanner(id: string) {
      if (!this.closedBanners.includes(id)) {
        this.closedBanners.push(id)
      }
    },
    removeClosedBanner(id: string) {
      this.closedBanners = this.closedBanners.filter((bannerId) => bannerId !== id)
    },
  },
})
